import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PostDto } from '../../../api/interfaces/Posts';
import { useLoader } from '../../../Loader/LoaderContext';
import { getService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import ReadMore from '../leads/ReadMore';
const ViewDetailsEvents: React.FC = () => {
  const [companyData, setcompanyData] = useState<any>(null);
  const [data, setData] = useState<PostDto>();
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const nameOfScreen = searchParams.get('name');
  const navigate = useNavigate();
  useEffect(() => {
    fetchVehicles();
  }, []);
  const getCompanyDetails = async (responseData: any) => {
    try {
      let url: any;
      if (
        responseData?.companyRespDto?.vendorType === 'HOSPITAL' &&
        responseData?.companyRespDto?.recordType === 'VENDOR'
      ) {
        url = API_ENDPOINTS.hospitalProfilling;
      } else if (
        responseData?.companyRespDto?.vendorType === 'COMPANY' &&
        responseData?.companyRespDto?.recordType === 'VENDOR'
      ) {
        url = API_ENDPOINTS.companyProfilling;
      } else if (
        responseData?.companyRespDto?.vendorType === 'EVENT_ORGANIZER' &&
        responseData?.companyRespDto?.recordType === 'VENDOR'
      ) {
        url = API_ENDPOINTS.eventProfilling;
      }

      if (responseData) {
        const response = await getService(
          `${url}?vendorId=${responseData?.companyRespDto?.id}`
        );
        setcompanyData(response.data);
      }
    } catch (error) {
      console.error('Error parsing stored data:', error);
    }
  };
  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let screen;
      let url: any;
      // url = API_ENDPOINTS.getPostsDetails
      if (userInfo.roles === 'CHIEF_EDITOR') {
        url = API_ENDPOINTS.getPostsDetailsCheif;
      } else if (userInfo.roles === 'JUNIOR_EDITOR') {
        url = API_ENDPOINTS.getPostsDetails;
      } else if (userInfo.roles === 'UPLOADER') {
        url = API_ENDPOINTS.getPostsDetailsUploader;
      } else if (userInfo.roles === 'PUBLISHER') {
        url = API_ENDPOINTS.getPostsDetailsPublisher;
      } else if (userInfo.roles === 'CONTENT_ADMIN') {
        url = API_ENDPOINTS.getCAPostDetails;
      } else {
        screen = 'viewDahboard';
        url = API_ENDPOINTS.post;
      }

      const response = await getService(url + '?id=' + userId);
      console.log(response);
      setData(response.data);
      getCompanyDetails(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const users = () => {
    if (nameOfScreen === 'viewPost') {
      navigate('/portals/posts/viewPosts');
    } else if (nameOfScreen === 'archived') {
      navigate('/portals/posts/archived');
    } else if (nameOfScreen === 'events') {
      navigate('/portals/posts/viewEventsPosts');
    } else if (nameOfScreen === 'expiredEvents') {
      navigate('/portals/posts/expiredEventsPosts');
    } else if (nameOfScreen === 'enquiryevents') {
      navigate('/portals/enquiries/events');
    } else if (nameOfScreen === 'vendorDashboardEvents') {
      navigate('/vendorDashboard/activateDashbord/eventListing');
    }
  };

  const handleEdit = (data: any) => {
    console.log('Edit clicked, data:', data);
    if (!data?.id) {
      console.error('Post ID is undefined');
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const name = params.get('name');
    if (data?.type === 'EVENT') {
      const navigateUrl = `/portals/posts/addEvents?appUserId=${data?.id}${
        name ? `&name=${name}` : ''
      }`;
      navigate(navigateUrl);
    } else {
      const navigateUrl = `/portals/posts/createPost?appUserId=${data?.id}${
        name ? `&name=${name}` : ''
      }`;
      navigate(navigateUrl);
    }
  };
  return (
    <div className='h-full py-2 w-full pr-8 mt-6'>
      <div className='flex justify-between mb-3 mr-[15px]'>
        <div className='flex items-center cursor-pointer'>
          <h2
            className='mr-2 text-gray-700 font-semibold text-sm'
            onClick={users}
          >
            {nameOfScreen === 'viewPost' || nameOfScreen === 'enquiryPost'
              ? 'Posts'
              : nameOfScreen === 'archived'
              ? 'Archived'
              : nameOfScreen === 'events' ||
                nameOfScreen === 'expiredEvents' ||
                nameOfScreen === 'enquiryevents' ||
                nameOfScreen === 'vendorDashboardEvents'
              ? 'Events'
              : 'Default Name'}
          </h2>
          <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
          <span className='text-gray-400 font-semibold text-sm truncate max-w-[800px] lg:max-w-[600px] md:max-w-[400px] sm:max-w-[200px]'>
            {data?.title}
          </span>
        </div>
        {data?.isEditable && (
          <div
            onClick={() => handleEdit(data)}
            className='flex items-center gap-2 cursor-pointer bg-white px-3 rounded-md border border-gray-300'
          >
            {' '}
            <img src='/images/editIcon.svg' />
            <a
              href='#'
              className='block py-2 text-sm text-[#374151] font-normal '
            >
              Edit Event
            </a>
          </div>
        )}
      </div>
      <div className=''>
        <div className='w-full flex gap-8'>
          <div className='w-[100%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4 bg-white  px-8  pt-6 scroolCls rounded-lg'>
            <div className='font-sans'>
              {data?.imageDto?.documentUrl && (
                <img
                  src={
                    data?.imageDto?.documentUrl
                      ? data?.imageDto?.documentUrl
                      : ''
                  }
                  className='w-[100%] h-[380px]'
                  alt='doctor'
                />
              )}
              <div className='flex'>
                <div className='w-[75%] pb-4'>
                  <h4 className='mt-8 flex'>
                    <span className='text-[#B00A2B] text-[20px] font-semibold whitespace-nowrap mr-1'>
                      Visit us:{' '}
                    </span>{' '}
                    <span className='text-[#2463EB] text-[20px] fond-normal'>
                      <a href={data?.eventReqDto?.link} target='_blank'>
                        {data?.eventReqDto?.link}
                      </a>
                    </span>
                  </h4>
                  <h1 className='text-gray-900 font-bold text-[32px] leading-10 mt-2'>
                    {data?.title}
                  </h1>
                  <p className='text-gray-600 text-base font-medium mt-2 break-words'>
                    {data?.description}
                  </p>
                  <div className='flex item-center justify-between bg-[#FFF7F7] p-4 rounded-[8px] my-6'>
                    <div className='flex items-center'>
                      <div className='ml-3 flex items-center'>
                        <h2 className='text-gray-800 text-base font-normal'>
                          {' '}
                        </h2>
                      </div>
                      <div className='ml-3 flex items-center'>
                        <img
                          src={
                            data?.companyRespDto?.imageDto?.documentUrl
                              ? data?.companyRespDto?.imageDto?.documentUrl
                              : '/images/dummpComapnyLogo.svg'
                          }
                          className='mr-2 size-[25px] rounded-full'
                        />
                        <span className='text-gray-900 text-base'>
                          <span className='font-normal'>By</span>{' '}
                          <span className='font-bold'>
                            {data?.companyName
                              ? data?.companyName
                              : data?.companyRespDto?.name
                              ? data?.companyRespDto?.name
                              : 'NA'}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='font-Inter mb-5'>
                    <p className='font-bold text-[24px] text-gray-900 mb-3'>
                      Date and Time
                    </p>
                    <div className='flex gap-2'>
                      <img
                        src='/images/calender.svg'
                        className='size-[24px] mr-2 cursor-pointer'
                      />
                      <p className='font-medium text-base text-gray-800'>
                        {data?.eventReqDto?.startDate &&
                        data?.eventReqDto?.endDate
                          ? `${data?.eventReqDto?.startDate} - ${data?.eventReqDto?.endDate}`
                          : 'NA'}
                      </p>
                    </div>
                  </div>
                  <div className='font-Inter mb-5'>
                    <p className='font-bold text-[24px] text-gray-900 mb-3'>
                      Location
                    </p>
                    <div className='flex gap-2'>
                      <img
                        src='/images/locationMark.svg'
                        className='size-[24px] mr-2 cursor-pointer'
                      />
                      <p className='font-normal text-gray-900 text-sm'>
                        {data?.eventReqDto?.venue
                          ? data?.eventReqDto?.venue
                          : 'Remote'}
                      </p>
                    </div>
                  </div>
                  <div className='font-Inter'>
                    <p className='font-bold text-[24px] text-gray-900 mb-3'>
                      About This Event
                    </p>
                    {data?.actualContent ? (
                      <div
                        className=' break-words ContentPost'
                        dangerouslySetInnerHTML={{
                          __html: data?.actualContent
                            .replace(
                              /<iframe/g,
                              '<div class="video-container"><iframe'
                            )
                            ?.replace(/<\/iframe>/g, '</iframe></div>')
                            .replace(/<p>\s*<\/p>/g, '') // Remove empty <p> tags
                            .replace(/<p><br><\/p>/g, '<br>') // Replace <p><br></p> with a single <br>
                            .replace(/<p>(.*?)<\/p>/g, '$1<br>'),
                        }}
                      />
                    ) : (
                      <p className='font-normal text-gray-900 text-sm'>NA</p>
                    )}
                  </div>
                </div>
                <div className='w-[35%] justify-items-end cursor-pointer mt-5'>
                  {(data?.authorDto || data?.leaderShipTeamDto) && (
                    <div className='border border-gray-200 rounded-lg p-3 md:p-5 bg-white py-6 px-8 mb-3'>
                      <p className='text-2xl font-bold text-gray-900 mb-5'>
                        Author Details
                      </p>
                      <div className='flex items-center mb-6'>
                        <img
                          src={
                            data?.authorDto?.imageDto?.documentUrl ||
                            data?.leaderShipTeamDto?.fileDto?.documentUrl ||
                            '/images/dummpComapnyLogo.svg'
                          }
                          className='size-[32px] mr-2 rounded-full'
                        />
                        <div>
                          <h2 className='text-gray-900 font-bold text-base'>
                            {data?.authorDto?.name ||
                              data?.leaderShipTeamDto?.name}
                          </h2>
                          <p className='font-semibold text-sm text-[#374151]'>
                            {data?.companyName}
                          </p>
                        </div>
                      </div>
                      <p>
                        <ReadMore
                          text={
                            data?.authorDto?.bio ||
                            data?.leaderShipTeamDto?.bio ||
                            'NA'
                          }
                          lines={2}
                        />
                      </p>
                    </div>
                  )}

                  {/* <button className="justify-end mt-8 border rounded-md font-bold text-base mb-10 px-10 py-2 text-white bg-custom-gradients">Enquire about this event</button> */}
                  <div className='border rounded-md py-3 px-5 ml-8 w-[80%]'>
                    {/* <p className="font-bold text-2xl text-gray-900 mb-3">Organized By</p> */}
                    <div className='flex gap-3 items-center mb-5'>
                      <img
                        src={
                          data?.companyRespDto?.imageDto?.documentUrl
                            ? data?.companyRespDto?.imageDto?.documentUrl
                            : data?.authorDtos?.imageDto?.documentUrl
                            ? data?.authorDtos?.imageDto?.documentUrl
                            : companyData?.imageDto?.documentUrl
                            ? companyData?.imageDto?.documentUrl
                            : '/images/dummpComapnyLogo.svg'
                        }
                        className='size-10 rounded-full'
                      />
                      <div>
                        <p className='font-bold text-base'>
                          {data?.companyName || companyData?.name || 'NA'}
                        </p>
                        {/* <p className="font-semibold text-sm text-[#374151]">ABC Company</p> */}
                      </div>
                      {(companyData?.companyInfo ||
                        companyData?.hospitalInfo) && (
                        <p>
                          <ReadMore
                            text={
                              companyData?.hospitalInfo ||
                              companyData?.companyInfo ||
                              'NA'
                            }
                            lines={2}
                          />
                        </p>
                      )}
                    </div>
                    {/* <p>
            ESS Groups is a lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. ABC Company is a lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. ABC Company is a lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. ABC Company is a lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
            </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className='sm:grid h-[50%] grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4 scroolCls rounded-lg'
            style={{ width: '30%' }}
          >
            <div className='bg-white py-6 px-6 rounded-lg mx-[13px] font-Inter'>
              <p className='text-2xl font-bold text-gray-900 mb-5'>
                SEO Meta Details
              </p>
              <div className='font-Inter'>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Meta Title
                </h2>
                <p className='font-normal text-sm text-[#374151] mb-5'>
                  {data?.seoMetaTitle ? data?.seoMetaTitle : 'NA'}
                </p>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Meta Description
                </h2>
                <p className='font-normal text-sm text-[#374151] mb-5'>
                  {data?.seoDescription ? data?.seoDescription : 'NA'}
                </p>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Keywords
                </h2>
                <p className='font-normal text-sm text-[#374151] mb-5'>
                  {data?.keyWords ? data?.keyWords : 'NA'}{' '}
                </p>
                <h2 className='text-[#374151] font-semibold text-base mb-1'>
                  Alt Text
                </h2>
                <p className='font-normal text-sm text-[#374151]'>
                  {data?.seoAltText ? data?.seoAltText : 'NA'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetailsEvents;
